import { GatewayContact } from "@conformite/gateway";
import { ParcoursAdhesionNextAction } from "@src/adhesion/AdhesionActions/ParcoursAdhesionNextAction";
import { ParcoursAdhesionSaveAndQuitAction } from "@src/adhesion/AdhesionActions/ParcoursAdhesionSaveAndQuitAction";
import {
  AdhesionStepEnum,
  ID_FORM_ADHESION,
  ParcoursAdhesionStepComponentProps,
} from "@src/adhesion/ParcoursAdhesion.definition";
import { ParcoursFullPageTemplate } from "@src/parcours/Template/ParcoursFullPageTemplate";
import {
  EntrepriseContactMediationForm,
  EntrepriseContactMediationFormHandle,
} from "@src/societes/form/EntrepriseContactMediationForm";
import { useRef } from "react";

export function AdhesionContactMediationPage({
  data,
  addData,
  changeStep,
  handleQuit,
}: ParcoursAdhesionStepComponentProps) {
  const formRef = useRef<EntrepriseContactMediationFormHandle>(null);

  return (
    <ParcoursFullPageTemplate
      title="Contact de médiation"
      actions={
        <>
          <ParcoursAdhesionSaveAndQuitAction
            addData={addData}
            formConfig={() => formRef?.current?.getFormConfig()}
            handleQuit={handleQuit}
            transformValues={(formValues) => ({
              contactMediation: {
                ...formValues,
                civiliteMediation:
                  formValues.civiliteMediation as GatewayContact.ContactCivilite,
              },
            })}
          />
          <ParcoursAdhesionNextAction type="submit">
            Suivant
          </ParcoursAdhesionNextAction>
        </>
      }
    >
      <EntrepriseContactMediationForm
        ref={formRef}
        defaultValues={data.contactMediation}
        onSubmit={(contactMediation) => {
          addData({
            contactMediation,
          });
          changeStep(AdhesionStepEnum.INFORMATIONS_COMPLEMENTAIRES);
        }}
        formId={ID_FORM_ADHESION}
      />
    </ParcoursFullPageTemplate>
  );
}
